export const isInfluencer = user => {
  const re = /influencer/gi;
  const tagName = (user && user.referral_payout_tag && user.referral_payout_tag.name) || '';
  return re.test(tagName);
};
